// extracted by mini-css-extract-plugin
export default {"wrapper":"MadeIactivePro_wrapper__-tBQR","made":"MadeIactivePro_made__le+G8"};